/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PseudonymAppointmentsQuizAnswerViewAliases {
  DYNAMIC_FIELDS_QUIZ_ANSWER_VIEW = 'dynamic-fields-quiz-answer-view',
  FORM_QUIZ_ANSWER_VIEW = 'form-quiz-answer-view',
  LAYOUT_QUIZ_ANSWER_VIEW = 'layout-quiz-answer-view',
  PANEL_QUIZ_ANSWER_VIEW = 'panel-quiz-answer-view',
}
export { PseudonymAppointmentsQuizAnswerViewAliases };
